import StylishVariantSelector from "../VariantSelector";

export default function ProductVariants({
    product,
    selected,
    onQuantityChange,
  }) {

      // تبدیل انگلیسی به فارسی
  const toPersianDigits = (str) => {
    return str.replace(/\d/g, (d) => String.fromCharCode(d.charCodeAt(0) + 1728));
  };

  
    return (
      <div className="mt-4 space-y-3">
        <StylishVariantSelector
          product={product}
          selected={selected}
          handleQuantityChange={onQuantityChange}
          toPersianDigits={toPersianDigits}
        />
      </div>
    );
  }